import React from 'react';
import './Contact2.css';

const TEXTS = {
  de: {
    ctaTitle: 'Kontakt aufnehmen',
    ctaButton: 'Kontaktieren Sie uns',
    subject: 'Reiseanfrage von der Website',
    body: 'Hallo AllegroTours,\n\nich interessiere mich für Ihre Reisen.\n\n'
  },
  en: {
    ctaTitle: 'Get in Touch',
    ctaButton: 'Contact Us',
    subject: 'Tour Inquiry from Website',
    body: 'Hello AllegroTours,\n\nI am interested in learning more about your tours.\n\n'
  },
  it: {
    ctaTitle: 'Mettiti in contatto',
    ctaButton: 'Contattaci',
    subject: 'Richiesta tour dal sito web',
    body: 'Ciao AllegroTours,\n\nsono interessato a saperne di più sui vostri tour.\n\n'
  }
};

const Contact2 = ({ content }) => {
  const language = content?.language || 'de';
  const t = TEXTS[language] || TEXTS.de;

  return (
    <section className="contact2-section">
      <div className="contact2-container">
        <h2 className="contact2-title">{content.contact_heading}</h2>
        
        <div className="contact2-grid">
          <div className="contact2-info">
            <div className="contact2-card">
              <div className="contact2-icon">🏢</div>
              <div className="contact2-details">
                <h3>ALLEGROTOURS</h3>
                <p>{content.contact_name}</p>
              </div>
            </div>

            <div className="contact2-card">
              <div className="contact2-icon">📍</div>
              <div className="contact2-details">
                <p>{content.contact_address}</p>
                <p>{content.contact_city}</p>
              </div>
            </div>

            <div className="contact2-card">
              <div className="contact2-icon">📞</div>
              <div className="contact2-details">
                <p><strong>Tel:</strong> <a href={`tel:${content.contact_phone}`}>{content.contact_phone}</a></p>
                <p><strong>Fax:</strong> <a href={`tel:${content.contact_fax}`}>{content.contact_fax}</a></p>
                <p><strong>Mobile:</strong> <a href={`tel:${content.contact_mobile}`}>{content.contact_mobile}</a></p>
              </div>
            </div>

            <div className="contact2-card">
              <div className="contact2-icon">✉️</div>
              <div className="contact2-details">
                <p><strong>Email:</strong></p>
                <p><a href={`mailto:${content.contact_email}`}>{content.contact_email}</a></p>
              </div>
            </div>
          </div>

          <div className="contact2-cta">
            <h3>{t.ctaTitle}</h3>
            <p>{content.accommodations_text}</p>
            <a 
              href={`mailto:${content.contact_email}?subject=${encodeURIComponent(t.subject)}&body=${encodeURIComponent(t.body)}`}
              className="contact2-button"
            >
              {t.ctaButton}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact2;
